import { useQuery } from "@tanstack/react-query";
import { REMOTE_CONFIG_KEYS } from "@/login/constants";
import { isUserInActiveList } from "@/login/utils/loginUtils";
import { useRemoteConfig } from "@/shared/hooks/useRemoteConfig";
import { useAuth } from '@/shared/hooks/useAuth';
import { fetchUsersWithBoardPermission } from "@/user/external/user.api";

export function useIsCurrentUserActive() {
    const { value: activeBoardId } = useRemoteConfig(REMOTE_CONFIG_KEYS.ACTIVE_BOARD_ID);
    const { data: userData, isLoading } = useQuery({
        queryKey: ['userData', activeBoardId],
        queryFn: () => fetchUsersWithBoardPermission([activeBoardId]),
        enabled: !!activeBoardId,
    });
    const { currentUser } = useAuth();
    const isCurrentUserActive = isUserInActiveList(userData, currentUser?.uid);

    return { isCurrentUserActive, isLoading };
}